import { z } from 'zod'

const ratingSchema = z.object({
  value: z.number(),
  count: z.number(),
  aggregated: z.object({
    1: z.number(),
    2: z.number(),
    3: z.number(),
    4: z.number(),
    5: z.number()
  }),
  raterList: z.array(
    z.object({
      name: z.string(),
      rating: z.number(),
      date: z.string().datetime()
    })
  )
}).optional()

const previewTokenSchema = z.object({
  url: z.string(),
  brand: z.string(),
  iat: z.number(),
  exp: z.number()
}).optional()

const foreignIdSchema = z.object({
  fId: z.string(),
  fName: z.string()
})

export const pageMetaSchema = z.object({
  rating: ratingSchema,
  isSeriesMaster: z.boolean().optional(),
  isSeriesMember: z.boolean().optional(),
  isSearch: z.boolean().optional(),
  seriesIndex: z.number().optional(),
  teaserFilter: z.string().optional(),
  seriesType: z.enum(['slide', 'browse']).optional(),
  unfoldToc: z.boolean().optional(),
  style: z.string().optional(),
  composerVersion: z.string().optional(),
  pageType: z.enum(['article', 'seriesArticle', 'structureterm']).optional(),
  articleType: z.enum(['article', 'recipe', 'gallery', 'video']).optional(),
  structureTermType: z.string().optional(),
  created: z.string().datetime().optional(),
  took: z.number().optional(),
  url: z.string().optional(),
  baseUrl: z.string().optional(),
  id: z.string().optional(),
  foreignIds: z.array(foreignIdSchema).optional(),
  nodeId: z.number().optional(),
  page: z.number().optional(),
  numPages: z.number().optional(),
  expirationDate: z.string().datetime().optional(),
  previewToken: previewTokenSchema,
  restrictedToRoles: z.array(z.string()).optional(),
  vgWortTrackingId: z.string().optional()
})

export type PageMeta = z.infer<typeof pageMetaSchema>
